import WebsitesModalWrapper from "app/pages/sales-intelligence/sub-modules/opportunities/components/modals/OpportunityListModal/WebsitesModalWrapper";
import {
    createOpportunityListAsync,
    toggleOpportunityListModal,
} from "app/pages/sales-intelligence/sub-modules/opportunities/store/action-creators";
import {
    createOpportunityListThunk,
    updateListOpportunitiesThunk,
} from "app/pages/sales-intelligence/sub-modules/opportunities/store/effects";
import { selectOpportunityListModal } from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";
import type {
    AddOpportunitiesToListDto,
    OpportunityListType,
} from "app/pages/sales-intelligence/sub-modules/opportunities/types";
import { useDispatch, useSelector } from "react-redux";
import { isActionOf } from "typesafe-actions";

type OpportunityListModalContainerProps = {
    isListDataLoading: boolean;
    onAddWebsites(list: OpportunityListType, dto?: AddOpportunitiesToListDto): void;
    onListCreate?(listId: string): void;
};

const OpportunityListModalContainer = (props: OpportunityListModalContainerProps) => {
    const { isListDataLoading, onAddWebsites, onListCreate } = props;

    const dispatch = useDispatch();

    const modalPayload = useSelector(selectOpportunityListModal);

    function handleToggle(isOpen: boolean, list?: OpportunityListType) {
        dispatch(toggleOpportunityListModal(isOpen, list));
    }

    async function handleListCreateSubmit(name: string, domains?: readonly string[]) {
        const createActionResult = await dispatch(createOpportunityListThunk(name, domains));
        const isSuccessfulAction = isActionOf(createOpportunityListAsync.success);

        if (isSuccessfulAction(createActionResult)) {
            onListCreate?.(createActionResult.payload.opportunityListId);
        }
    }

    async function handleListUpdateSubmit(dto: AddOpportunitiesToListDto) {
        if (typeof modalPayload.list === "undefined") {return false;}

        const updatedList = await dispatch(updateListOpportunitiesThunk(modalPayload.list.opportunityListId, dto));

        if (updatedList && "opportunityListId" in updatedList) {
            onAddWebsites(modalPayload.list, dto);
            return true;
        }

        return false;
    }

    return (
        <WebsitesModalWrapper
            modalPayload={modalPayload}
            isListDataLoading={isListDataLoading}
            onToggle={handleToggle}
            onListCreateSubmit={handleListCreateSubmit}
            onListUpdateSubmit={handleListUpdateSubmit}
        />
    );
}

export default OpportunityListModalContainer;
